export default __webpack_public_path__ + "static/media/DJI_0941.MP4.00_02_16_00.Still002.532206e6.jpg";